import NotFoundPage from 'components/pages/NotFoundPage';
export default NotFoundPage;
